import { render, staticRenderFns } from "./ToolSection.vue?vue&type=template&id=1ae191de&scoped=true"
import script from "./ToolSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToolSection.vue?vue&type=style&index=0&id=1ae191de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae191de",
  null
  
)

export default component.exports